import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { QuestionStoreModel } from '@examdojo/question';
import { DerivativeQuestionReviewType, QuestionReviewFeedbackFormState } from '@examdojo/review';
import { HumanReviewSidebarComponent } from './human-review-sidebar/human-review-sidebar.component';
import { StandardReviewSidebarComponent } from './standard-review-sidebar/standard-review-sidebar.component';

@Component({
  selector: 'dojo-derivative-question-sidebar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @switch (true) {
      @case (reviewType() === QuestionReviewType.HumanReview) {
        <dojo-human-review-sidebar
          #sidebarComponent
          [reviewType]="reviewType()"
          [hidden]="activeItem()"
          [isSubmitting]="isSubmitting()"
          [question]="question()"
          [calculatorAllowed]="calculatorAllowed()"
          (formStateChange)="formStateChange.emit($event)"
        />
      }
      @default {
        <dojo-standard-review-sidebar
          #sidebarComponent
          [reviewType]="reviewType()"
          [hidden]="activeItem()"
          [isSubmitting]="isSubmitting()"
          [question]="question()"
          [calculatorAllowed]="calculatorAllowed()"
          (formStateChange)="formStateChange.emit($event)"
        />
      }
    }
  `,
  imports: [StandardReviewSidebarComponent, HumanReviewSidebarComponent],
  host: { class: 'flex h-full flex-col' },
})
export class DerivativeQuestionSidebarComponent {
  readonly formStateChange = output<QuestionReviewFeedbackFormState>();

  readonly QuestionReviewType = DerivativeQuestionReviewType;

  readonly reviewType = input.required<DerivativeQuestionReviewType>();
  readonly isSubmitting = input(false);
  readonly question = input.required<QuestionStoreModel>();
  readonly calculatorAllowed = input.required<boolean>();

  readonly activeItem = input(false);
}
